export const MIN_LAND_UNIT_TOOLTIPS_ZOOM_LEVEL = 17;
export const MIN_RECENT_OPERATION_ZOOM_LEVEL = 16;

export enum LAND_UNIT_TOOLTIP_TYPE {
  FLOOR_AREA = 'floor area',
  SALES_REVENUE = 'sales revenue',
  MARKET_VALUE = 'market value',
  RECENT_OPERATIONS = 'recent operations',
}
